import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faEnvelopeOpen } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import moment from 'moment';
import { Col, UncontrolledTooltip } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { actions } from '../../../context';
import CommentAttachment from './CommentAttachment';

const Comment = ({ comment, refresh }) => {
    const dispatch = useDispatch();
    const markAsUnread = () => {
        dispatch(actions.communication.markCommentAsUnread(comment.id)).then(
            () => refresh(false, false)
        );
    };

    const highlightMentions = (text) =>
        text.split(':@:@:').map((str, index) => (
            <span
                key={index}
                className={`${
                    index % 2 === 1
                        ? `text-light border-bottom border-light`
                        : `text-light`
                }`}>
                {index % 2 === 1 && <>@</>}
                {str}
            </span>
        ));

    const renderCommentText = (comment) => {
        if (comment === undefined) return <></>;
        return comment.split(/\n/g).map((paragraph, index) => {
            return <p key={index}>{highlightMentions(paragraph)}</p>;
        });
    };

    return (
        <div
            className={classNames('mb-4 w-90 border-bottom p-1 mb-2', {
                'ml-auto': comment.isUsersComment,
                'border-danger': comment.hasBeenSeen === false,
            })}>
            <div className="d-flex justify-content-between">
                <div className={classNames('mb-4 text-14')}>
                    {comment.commentUser}&emsp;
                    {moment
                        .unix(comment.createdDate)
                        .local()
                        .format('MMM D, YYYY LT')}
                </div>
                <FontAwesomeIcon
                    id={`markUnread${comment.id}`}
                    className={classNames('pop-hover', {
                        'd-none': comment.isUsersComment === true,
                    })}
                    icon={faEnvelopeOpen}
                    onClick={markAsUnread}
                />
                <UncontrolledTooltip target={`markUnread${comment.id}`}>
                    Mark as unread
                </UncontrolledTooltip>
            </div>
            {comment.text && <Col>{renderCommentText(comment.text)}</Col>}
            {(comment.attachments || []).map((a, x) => (
                <CommentAttachment attachment={a} key={x} />
            ))}
            {comment.hasFile && (
                <Col className="mb-2">
                    {comment.text && comment.text.length > 0 && <br />}
                    <a
                        className="text-decoration-none"
                        download={comment.fileName}
                        href={comment.file}
                        target="_blank"
                        rel="noreferrer">
                        {comment.file.substring(0, 10) === 'data:image' ? (
                            <img
                                className={classNames('rounded shadow')}
                                style={{ maxWidth: '90%' }}
                                src={comment.file}
                                title={comment.fileName}
                                alt={`comment attachment: ${comment.fileName}`}></img>
                        ) : (
                            <div
                                className="bg-dark-opacity-3 text-white p-3 rounded d-inline-block px-0 hide-overflow"
                                style={{ maxWidth: '100%' }}
                                title={comment.fileName}>
                                <FontAwesomeIcon icon={faFileAlt} size="lg" />{' '}
                                &nbsp; &nbsp;
                                {comment.fileName}
                            </div>
                        )}
                    </a>
                </Col>
            )}
        </div>
    );
};

export default Comment;
